import { IBridge } from "./IBridge";

/**
 * Rozhraní proxy pro bridge modul, které umožňuje vyměnit implementaci bridge v runtime.
 * Určeno pouze pro neprodukční použití (unit testy, Storybook).
 *
 * Proxy používá jako výchozí implementaci "mock" modul bridge.
 */
export interface IProxyBridge extends IBridge {

    /**
     * Nastaví implementaci bridge, která je z proxy provolávaná.
     * Pokud byl ProxyBridge inicializován pomocí {@link IBridge.setStore}, pak provede inicializaci nastavené implementace pomocí volání {@link IBridge#setStore} a pokud
     * má nastavená implementace v {@link IBridge#module} definovanou ságu, spustí ji.
     *
     * Pokud se nastavuje nová implementace a předchozí implementace měla ságu, pak je předchozí
     * sága zrušena.
     *
     * @param bridgeImpl Implementace bridge k nastavení.
     */
    setBridgeImpl(bridgeImpl: IBridge): void;

    /**
     * Nastaví provolávanou implementaci bridge na výchozí hodnotu, kterou je "mock" modul.
     * Hodí se např. v unit testech pro návrat proxy bridge do původního stavu po nastavení
     * vlastní implementace pomocí {@link setBridgeImpl}.
     */
    resetToDefaultImpl(): void;
}

export class IProxyBridge {
    private static _methods = ["setBridgeImpl", "resetToDefaultImpl"];
    // není třeba kontrolovat obsah rozhraní IBridge, protože proxy se využívá pouze v neprodukčním prostředí, kde je riziko zanedbatelné

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            this._methods.every(value => typeof instance[value] === "function");
    }
}
